export const stepTitlesDesktop: string[] = [
    'Travel & Visa Details',
    'Application Review'
]

export const visaItineraryTitles: string[] = [
    'Traveller Information',
    'Application Review'
]

export const stepTitlesMobile: string[] = [
    'Travel & Visa',
    'Review'
]

export const CONFIRMED = 'CONFIRMED'
export const REJECTED = 'REJECTED'
